module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_1@2x.972ab94c.png";